var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classList,attrs:{"role":"radiogroup","errors":""}},[_vm._t("default"),_c('p',{staticClass:"radio_group__error"},[_vm._v(" "+_vm._s(_vm.validationError)+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }